import React from "react";
import { withTranslation } from "react-i18next";
import { DigitalContractDashboardView } from "../../views";
import {
  LocalStorageService,
  ClientCompanyService,
  ClientContractService,
} from "../../../services/index";
import moment from "moment";
import "moment/locale/es";
import {
  TemplateAdministration,
  NewContract,
  ContractAdministration,
  QuestionnaireAdministration,
} from "../../../assets/logos/icons";

class DigitalContractDashboardAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      planName: "",
      dateStart: new Date(),
      dateLimit: new Date(),
      clientContract: [],
      clientPerApplicant: [],
      itemsCardsDashboard: [
        {
          img: NewContract,
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
          altImg: props.t("digitalContractDashboardAction.newContract"),
          title: props.t("digitalContractDashboardAction.newContract"),
          text: props.t("digitalContractDashboardAction.newContracText"),
          url: "/contract-request",
        },
        {
          img: ContractAdministration,
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
          altImg: props.t("digitalContractDashboardAction.contractFollowup"),
          title: props.t("digitalContractDashboardAction.contractFollowup"),
          text: props.t("digitalContractDashboardAction.contractFollowupText"),
          url: "/followup-contracts",
        },
        {
          img: QuestionnaireAdministration,
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
          title: props.t(
            "digitalContractDashboardAction.questionnaireAdministration"
          ),
          text: props.t(
            "digitalContractDashboardAction.questionnaireAdministrationText"
          ),
          url: "/questionnaire-administration",
        },
        {
          img: TemplateAdministration,
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
          altImg: props.t(
            "digitalContractDashboardAction.templatesAdministration"
          ),
          title: props.t(
            "digitalContractDashboardAction.templatesAdministration"
          ),
          text: props.t(
            "digitalContractDashboardAction.templatesAdministrationText"
          ),
          url: "/templates",
        }
      ],
      statusContracts: [],
      contractsForLawyers: [],
      cardSpinnerText: [
        { text: "Contratos solicitados" },
        { text: "Solicitudes detenidas" },
      ],
      percentageProgress: [],

      clientPerApplicant: [],

      clienContractByQuestionnaire: [],
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  clientCompanyService = new ClientCompanyService(this.url);
  clientContractService = new ClientContractService(this.url);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    let userType = this.user.userMetaData.userRoles;

    try {
      moment.locale("es");
      let dateStartOneYear = moment().subtract(1, "year");
      let dateModification = moment(dateStartOneYear).format("DD/MM/YYYY");
      //Date today
      let dateLimit = moment(new Date()).format("DD/MM/YYYY");

      let userIsAdmin = false
      userType.map((type) => {
        // Id lawyer, id client, id seller
        if (type.role.key === process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_MANAGER || type.role.key === process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_MEMBER || type.role.id === 12 || type.role.key === process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_SUPER_LAWYER) {
          let itemsCardsDashboardNew = this.state.itemsCardsDashboard.filter(
            (item) =>
              item.title !== "Administrar Cuestionarios" &&
              item.title !== "Administrar Templates"
          );
          this.setState({
            // disableCard: true,
            roleUserId: type.role.id,
            itemsCardsDashboard: itemsCardsDashboardNew,
            disableGridLawyer: true,
            disabledGridClient: false,
          });
        }
        // Id client
        if (type.role.key === process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_MEMBER) {
          this.setState({
            disableCard: true,
            disabledGridClient: true,
          });
        }
        //Id seller
        if (type.role.id === 12) {
          this.setState({
            disableCard: true,
            disabledGridClient: true,
          });
        }

        if (type.role.key === process.env.REACT_APP_ADMIN || type.role.key === process.env.REACT_APP_ADMIN_DIGITAL_CONTRACT) {
          userIsAdmin = true
        }
      });

      //Add  item standar contracts
      if (userIsAdmin) {
        let standatContracts = {
          img: TemplateAdministration,
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
          altImg: this.props.t(
            "digitalContractDashboardAction.templatesAdministration"
          ),
          title: "Contratos Estándar",
          text: "Selecciona un contrato estándar, haz una copia, personalízalo y úsalo. Ahorra tiempo.",
          url: "/questionnaire-administration",
          state: {
            standardContract: true
          }
        }
        let cards = this.state.itemsCardsDashboard
        cards.push(standatContracts)

        this.setState({
          itemsCardsDashboard: cards
        })
      }

      //Service dashboard
      let clientContract = await this.clientContractService.getClientContract(
        this.token,
        dateModification,
        dateLimit
      );
      //Circular progress
      this.state.cardSpinnerText.map((porcent) => {
        porcent.contractsDelivered =
          clientContract.data[0].countTotalContractsDelivered;
        porcent.contractsAlgo = clientContract.data[0].countTotalContracts;

        return this.state.cardSpinnerText;
      });

      //Filter contractStatus
      let statusContract = clientContract.data[0].workflowStatus.filter(
        (status) => status.workflowExecutionName !== "Pendiente Contratante"
      );

      //Contracts per lawyer grid
      clientContract.data[0].clientContractUserAttorney.map((lawyer) => {
        lawyer.nameLawyer =
          lawyer.firstName +
          " " +
          lawyer.firstLastName +
          " " +
          lawyer.secondLastName;

        return clientContract.data[0].clientContractUserAttorney;
      });

      //Contracts per applicant grid
      clientContract.data[0].clientContractUserRequesting.map((client) => {
        client.nameClient =
          client.firstName +
          " " +
          client.firstLastName +
          " " +
          client.secondLastName;
        return clientContract.data[0].clientContractUserRequesting;
      });

      // Questionnaire Chart
      clientContract.data[0].clienContractByQuestionnaire.map((question) => {
        question.label = question.questionnaireName;
        question.id = question.clientContractByQuestionnaireId;
        question.x = parseInt(question.countContractsByQuestionnaire, 10);
        return clientContract.data[0].clienContractByQuestionnaire;
      });

      let percentageProgress = [
        {
          countTotalContractsDelivered:
            clientContract.data[0].countTotalContractsDelivered,
          text: "Contratos solicitados",
          text2: clientContract.data[0].countTotalContracts,
          valueChart: clientContract.data[0].countTotalContracts,
        },
        // {
        //   percentageContractsDelivered:
        //     clientContract.data[0].percentageContractsDelivered,
        //   text: "Firmados",
        //   text2:
        //     clientContract.data[0].indicadores[0].indicadorFirmadoVsEntregados +
        //     "" +
        //     "%",
        //   valueChart:
        //     clientContract.data[0].indicadores[0].indicadorFirmadoVsEntregados,
        // },
        {
          percentageContractsDelivered:
            clientContract.data[0].percentageContractsDelivered,
          text: "Contratos entregados",
          text2:
            parseFloat(clientContract.data[0].indicadores[0]
              .indicadorEntregadosVsSolicitados).toFixed(0) +
            "" +
            "%",
          valueChart:
            clientContract.data[0].indicadores[0]
              .indicadorEntregadosVsSolicitados,
        },
        // {
        //   percentageContractsDelivered:
        //     clientContract.data[0].percentageContractsDelivered,
        //   text: "Bóveda Digital",
        //   text2:
        //     clientContract.data[0].indicadores[0]
        //       .indicadorResguardosVsSolicitados +
        //     "" +
        //     "%",
        //   valueChart:
        //     clientContract.data[0].indicadores[0]
        //       .indicadorResguardosVsSolicitados,
        // },
      ];

      this.setState({
        token: this.token,
        loading: false,
        clientContract: clientContract.data,
        statusContracts: statusContract,
        contractsForLawyers: clientContract.data[0].clientContractUserAttorney,
        clienContractByQuestionnaire: this.state.clienContractByQuestionnaire,
        clientPerApplicant: clientContract.data[0].clientContractUserRequesting,

        percentageProgress,
      });
    } catch (error) {
      this.props.history.push("/");
      this.setState({
        clientContract: [],
        statusContracts: [],
        clienContractByQuestionnaire: [],
        loading: false,
      });
    }
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
    // this.setState({
    //   showLoadingRequesting: value,
    // });
    // setTimeout(() => {
    //   this.setState({
    //     showLoadingRequesting: false,
    //   });
    // }, 4000);
  };

  toggleCompletedRequesting = (value, message, clientCompany) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            clientCompany: clientCompany,
          });
        }, 4000);
      }
    );
  };

  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false, message: "" });
        }, 4000);
      }
    );
  };

  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({ showWarningRequesting: false, message: "" });
        }, 4000);
      }
    );
  };

  render() {
    return (
      <DigitalContractDashboardView
        {...this.state}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleWarningRequesting={this.toggleWarningRequesting}
      />
    );
  }
}

export default withTranslation()(DigitalContractDashboardAction);
